export enum BudgetStatus {
    Pending,
    Approved,
    Rejected,
}

export interface Budget {
    id: string;
    status: BudgetStatus;
    createdAt: Date;
    name: string;
    amount: number;
}
